export default __webpack_public_path__ + "89a5a9575aa783fbefedf61bca94807d.woff2";